import { v4 as uuidv4 } from 'uuid';
import { unsubscribeAPI } from './api';

export function expandSubscriptions(subscriptionId) {
    this.subscriptionsExpanded[subscriptionId] = true;
    this.observed.subscriptionsExpanded = uuidv4();
}

export function closeSubscriptions(subscriptionId) {
    this.subscriptionsExpanded[subscriptionId] = false;
    this.observed.subscriptionsExpanded = uuidv4();
}

export async function unsubscribe(subscription) {
    const session = this.env.session;
    const traceId = this.env.traceId;

    // Optimistic: remove from active and move to inactive immediately
    this.deleteInActiveSubscriptions({ subscription });
    this.addInInactiveSubscriptions({ subscription });

    this.env.startLoadCounter({ target: 'loadingUnsubscribe' });

    const res = await unsubscribeAPI({ store: this, token: session.token, traceId, subscriptionId: subscription.id });

    this.env.stopLoadCounter();

    if (res?.error) {
        // Rollback: restore to active, remove from inactive
        this.inactiveSubscriptions = this.inactiveSubscriptions.filter((s) => s.id !== subscription.id);
        subscription.isActive = true;
        this.subscriptions = [subscription, ...this.subscriptions];
        this.observed.subscriptions = uuidv4();
        return;
    }

    this.observed.unsubscribe = uuidv4();
}

export function removeItemFromUnsubscribeList() {
    this.unsubscribeList.pop();
}
